<script lang="ts">
  export let description: string = "";

  const truncationLength = 40;

  let showMore = false;

  const truncateDescription = function (description: string) {
    if (!description || description.length < truncationLength) return description;

    let words = description.split(" ").slice(0, -1);
    let truncatedString = words.shift();

    words.every(word => {
      truncatedString += ` ${word}`;
      return truncatedString.length < truncationLength;
    });

    return truncatedString;
  };

</script>

{#if showMore || !description || description.length < truncationLength}
  <p style="font-style: italic;">
    {description}
  </p>
  {#if description?.length >= truncationLength}
    <p
      style="color: #127CA5; cursor: pointer;"
      on:click={() => {
        showMore = false;
      }}
    >
      Show less
    </p>
  {/if}
{:else}
  <p style="font-style: italic;">
    {truncateDescription(description)}...
  </p>
  <p
    style="color: #127CA5; cursor: pointer;"
    on:click={() => {
      showMore = true;
    }}
  >
    Show more
  </p>
{/if}
